import { FC, useState } from "react";
import SwiperCore from "swiper/core";
import SwiperClass from "swiper/types/swiper-class";
import { LazyImageProvider } from "src/molecules/Lazyimage/LazyImageContext";
import {
  StyledThumbnailContainer,
  StyledButtonBack,
  StyledButtonNext,
  StyledSwiper,
  StyledSwiperSlide,
} from "./ProductThumbnails.styled";
import LazyImage from "src/molecules/Lazyimage/Lazyimage";
import { ChevronDown } from "src/icons/ChevronDown";
import { MAX_THUMBNAILS_PER_VIEW } from "src/config";
import { AccessibilityProps } from "src/types/AccessibilityProps";

interface Props extends AccessibilityProps {
  thumbsSwiper?: SwiperClass;
  setThumbsSwiper: (swiper: SwiperCore) => void;
  photos: string[];
  activeSlide: number;
  isclient?: boolean;
}

const ProductThumbnails: FC<Props> = ({
  setThumbsSwiper,
  photos,
  activeSlide,
  isclient,
  ...rest
}) => {
  const [thumbnailSliderPosition, setThumbnailSliderPosition] =
    useState<number>(0);

  const slideDown = () =>
    setThumbnailSliderPosition((currentPosition) => currentPosition + 1);
  const slideUp = () =>
    setThumbnailSliderPosition((currentPosition) => currentPosition - 1);

  return (
    <LazyImageProvider>
      <StyledThumbnailContainer {...rest}>
        <StyledSwiper
          direction="vertical"
          initialSlide={0}
          height={620}
          spaceBetween={8}
          slidesPerView={MAX_THUMBNAILS_PER_VIEW}
          onSlideChange={(swiperInstance) => {
            if (swiperInstance.activeIndex > swiperInstance.previousIndex) {
              slideDown();
            } else {
              slideUp();
            }
          }}
          watchSlidesVisibility
          watchSlidesProgress
          navigation={{
            prevEl: "#swiper-thumb__prev-button",
            nextEl: "#swiper-thumb__next-button",
          }}
          isclient={isclient ? "true" : undefined}
          onSwiper={setThumbsSwiper}
        >
          {photos?.map((photo, index) => (
            <StyledSwiperSlide
              key={index}
              role="option"
              tag="button"
              tabIndex={0}
              aria-current={index === activeSlide}
              aria-selected={index === activeSlide}
            >
              <LazyImage
                aspectRatio={[2, 3]}
                src={photo}
                hasBorder={index === activeSlide}
                isClient={isclient}
              />
            </StyledSwiperSlide>
          ))}
        </StyledSwiper>

        <StyledButtonBack
          id="swiper-thumb__prev-button"
          shouldHide={
            photos.length <= MAX_THUMBNAILS_PER_VIEW ||
            thumbnailSliderPosition === 0
          }
          tabIndex={0}
        >
          <ChevronDown />
        </StyledButtonBack>
        <StyledButtonNext
          id="swiper-thumb__next-button"
          shouldHide={
            photos.length <= MAX_THUMBNAILS_PER_VIEW ||
            thumbnailSliderPosition === photos.length - MAX_THUMBNAILS_PER_VIEW
          }
          tabIndex={0}
        >
          <ChevronDown />
        </StyledButtonNext>
      </StyledThumbnailContainer>
    </LazyImageProvider>
  );
};

export default ProductThumbnails;
